import React from "react";

const SeoPageNotFound = () => {
  const hostname = window.location.hostname;

  const parts = hostname.split(".");
  const subdomain = hostname.includes("localhost")
    ? "main"
    : parts.length > 2
      ? parts[0]
      : "main";

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.code}>404</h1>
        <h2 style={styles.title}>Store Not Found</h2>

        <p style={styles.text}>
          The store <strong style={{ color: "#6366f1" }}>{subdomain}</strong> is
          not available.
        </p>

        <p style={styles.domainText}>
          Domain: <span>{hostname}</span>
        </p>

        <p style={styles.subtext}>
          This store does not exist or may have been deactivated.
        </p>

        <div style={styles.buttonGroup}>
          <a href='https://app.dukanbuddy.com' style={styles.primaryBtn}>
            Go to Main Website
          </a>

          <a href='mailto:support@cogitofs.com' style={styles.secondaryBtn}>
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eef2ff, #f8fafc)",
    padding: "20px",
  },
  card: {
    background: "white",
    padding: "50px 40px",
    borderRadius: "16px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "100%",
  },
  code: {
    fontSize: "80px",
    margin: 0,
    fontWeight: 700,
    color: "#6366f1",
  },
  title: {
    margin: "10px 0",
    fontSize: "28px",
  },
  text: {
    fontSize: "16px",
    margin: "20px 0 10px",
  },
  domainText: {
    fontSize: "14px",
    marginBottom: "10px",
    color: "#374151",
  },
  subtext: {
    fontSize: "14px",
    color: "#6b7280",
  },
  buttonGroup: {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  primaryBtn: {
    background: "#6366f1",
    color: "white",
    padding: "12px 20px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: 600,
  },
  secondaryBtn: {
    border: "1px solid #6366f1",
    color: "#6366f1",
    padding: "12px 20px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: 600,
  },
};

export default SeoPageNotFound;
